// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep body {
  overflow: auto !important;
}

.show {
  display: inline;
}

.hide {
  display: none;
}

.disableScroll {
  overflow-y: hidden;
  height: 100vh;
}
.disableScroll .logo-animation {
  position: absolute;
  z-index: 10000;
  background: #0c1a38;
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-y: hidden;
}
.disableScroll .logo-animation .logo-top {
  max-width: 300px;
  display: none;
}
.disableScroll .logo-animation .logo_bottom {
  transform: scale(0);
  max-width: 300px;
  margin-top: -80px;
}

.logo-animation {
  position: absolute;
  z-index: 10000;
  background: #0c1a38;
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-y: hidden;
}
.logo-animation .logo-top {
  max-width: 300px;
  display: none;
}
.logo-animation .logo_bottom {
  transform: scale(0);
  max-width: 300px;
  margin-top: -80px;
}`, "",{"version":3,"sources":["webpack://./src/app/layout/home-layout/home-layout.component.scss"],"names":[],"mappings":"AACI;EACI,yBAAA;AAAR;;AAIC;EACG,eAAA;AADJ;;AAGA;EACI,aAAA;AAAJ;;AAEA;EACI,kBAAA;EACA,aAAA;AACJ;AAAI;EACQ,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAEZ;AAAY;EACI,gBAAA;EACA,aAAA;AAEhB;AACY;EACI,mBAAA;EACA,gBAAA;EACA,iBAAA;AAChB;;AAGA;EACI,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAAJ;AAEI;EACI,gBAAA;EACA,aAAA;AAAR;AAGI;EACI,mBAAA;EACA,gBAAA;EACA,iBAAA;AADR","sourcesContent":[" :host ::ng-deep {\n    body{\n        overflow: auto!important;\n    }\n\n }\n .show{\n    display: inline;\n}\n.hide{\n    display: none;\n}\n.disableScroll{\n    overflow-y: hidden;\n    height:100vh;\n    .logo-animation {\n            position: absolute;\n            z-index: 10000;\n            background: #0c1a38;\n            width: 100%;\n            height: 100vh;\n            margin: 0 auto;\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            align-items: center;\n            overflow-y: hidden;\n    \n            .logo-top {\n                max-width: 300px;\n                display: none;\n            }\n    \n            .logo_bottom {\n                transform: scale(0);\n                max-width: 300px;\n                margin-top: -80px;\n            }\n        }\n}\n.logo-animation {\n    position: absolute;\n    z-index: 10000;\n    background: #0c1a38;\n    width: 100%;\n    height: 100vh;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    overflow-y: hidden;\n\n    .logo-top {\n        max-width: 300px;\n        display: none;\n    }\n\n    .logo_bottom {\n        transform: scale(0);\n        max-width: 300px;\n        margin-top: -80px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
